import { render, staticRenderFns } from "./risenewslist.vue?vue&type=template&id=256fb3f2&scoped=true&"
import script from "./risenewslist.vue?vue&type=script&lang=js&"
export * from "./risenewslist.vue?vue&type=script&lang=js&"
import style0 from "./risenewslist.vue?vue&type=style&index=0&id=256fb3f2&lang=less&scoped=true&"
import style1 from "./risenewslist.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256fb3f2",
  null
  
)

export default component.exports